import List from './list';
import New from './new';
import View from './view';

export default {
  List,
  New,
  View,
};
